import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent, ref, computed, nextTick } from "vue";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { ModalComponents, ModalStatus } from "@/constants/modal";
import ModalModule from "@/store/modules/modal";
import { PCTypes, RetailOptionType } from "@/types/db/product-category";
import { sumArray } from "@/utils/helpers/common";
import { createImageproxyUrl } from "@/utils/helpers/pictures";
import AppModule from "@/store/modules/app";
import { addToBasket, allowSharedStocksOverBooking, isProductAvailable, isSharedStocksWithOverbooking, selectPC } from "@/utils/vue-helpers/product-category";
import { sellOnSoldOut } from "@/utils/helpers/product-category";
import NotificationService from "@/services/notification.service";
import { useI18n } from "vue-i18n";
import POSConfigModule from "@/store/modules/pos-config";
import dayjs from "dayjs";
import closeIcon from "@/assets/images/svg/close.svg";
import { ElNotification } from "element-plus";
import fr from "element-plus/lib/locale/lang/fr";
import de from "element-plus/lib/locale/lang/de";
import en from "element-plus/lib/locale/lang/en";
import it from "element-plus/lib/locale/lang/it";
import BookingModule from "@/store/modules/booking";
import { groupedPSS } from "@/utils/vue-helpers/booking";
import { BookingStep } from "@/constants/booking";
import CashFloatModule from "@/store/modules/cash-float";
import { getPriceNonAutomaticAddons } from "@/utils/vue-helpers/product-slot-state";
import { hasAddonsEnabled } from "@/utils/vue-helpers/addons";
import { es } from "element-plus/es/locale";
import { queryTimeslotsByProductCategories } from "@/dexie/timeslots";
import { searchProductCategories } from "@/dexie/product-category";
export default defineComponent({
  name: ModalComponents.Products,
  components: {},
  setup: function setup() {
    var _useI18n = useI18n({}),
        t = _useI18n.t;

    var modalVisible = dialogVisibleForStatus(ModalStatus.Products);
    var products = ref([]);
    var searchQuery = ref("");
    var pageSize = ref(10);
    var currentPage = ref(1);
    var selectedDate = ref(new Date());
    var datepicker = ref();
    var selectedRecurringTicket = ref(null);
    var emitterRef = ref(); // for handling long clicks

    var clickPeriod = ref(0);
    var startTime = ref(0);
    var endTime = ref(0);
    var handleLongClickInterval = ref(); // for handling success notifications rate

    var notification = ref(null);
    var notificationCounter = ref(1);
    var notificationInterval = ref();
    var productsCount = computed(function () {
      return products.value.length;
    });
    var paginatedProducts = computed(function () {
      var startIndex = (currentPage.value - 1) * pageSize.value;
      var endIndex = startIndex + pageSize.value;
      return products.value.slice(startIndex, endIndex);
    });
    var canSell = computed(function () {
      // User can sell if not in completed ui and if sales started
      return BookingModule.bookingStep !== BookingStep.CompleteOrder && CashFloatModule.cashFloat;
    });
    var locale = computed(function () {
      var languages = {
        fr: fr,
        de: de,
        en: en,
        it: it,
        es: es
      };
      var currentLanguage = AppModule.language;
      var loc = languages[currentLanguage];
      return loc;
    });
    var groupedPssList = computed(function () {
      var _BookingModule$select;

      return groupedPSS(((_BookingModule$select = BookingModule.selectedBooking) === null || _BookingModule$select === void 0 ? void 0 : _BookingModule$select.pssList) || []);
    });
    var productsPssCount = computed(function () {
      var sumById = {};
      var result = groupedPssList.value.reduce(function (acc, current) {
        var id = current.categoryId;
        var value = current.quantity;

        if (!acc[id]) {
          acc[id] = value;
        } else {
          acc[id] += value;
        }

        return acc;
      }, sumById);
      return result;
    });

    function updateProducts() {
      return _updateProducts.apply(this, arguments);
    }

    function _updateProducts() {
      _updateProducts = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, i;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return searchProductCategories(searchQuery.value);

              case 2:
                res = _context2.sent;
                i = 0;

              case 4:
                if (!(i < res.length)) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 7;
                return addProductData(res[i]);

              case 7:
                res[i] = _context2.sent;

              case 8:
                i++;
                _context2.next = 4;
                break;

              case 11:
                products.value = res;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _updateProducts.apply(this, arguments);
    }

    function addProductData(_x) {
      return _addProductData.apply(this, arguments);
    }

    function _addProductData() {
      _addProductData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(p) {
        var product, now, timeslots;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                product = p;
                product.productCategoryId = product.id;

                if (!(product.type === PCTypes[PCTypes.Retail])) {
                  _context3.next = 5;
                  break;
                }

                product.dbAvailability = countAvailability(product);
                return _context3.abrupt("return", product);

              case 5:
                now = new Date().toISOString(); // a- get corresponding future timeslot data
                // b- assign timeslot data to the current product

                if (product.isRecurring) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 9;
                return queryTimeslotsByProductCategories({
                  categoryIds: [product.id],
                  endDateTimeAfter: now,
                  limit: 1
                });

              case 9:
                timeslots = _context3.sent;

                if (timeslots && timeslots.length) {
                  product.dbAvailability = timeslots[0].availability;
                  product.startDateTime = timeslots[0].startDateTime;
                  product.endDateTime = timeslots[0].endDateTime;
                  product.timeslot_ID = timeslots[0]._id;
                }

              case 11:
                return _context3.abrupt("return", product);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _addProductData.apply(this, arguments);
    }

    function allowSelectProduct(product) {
      var condition = //isSalesPeriod(product) &&
      isProductAvailable(product) > 0 || //for products that can be sold on 0 zero stock checking that the stock is equal to null or less
      isProductAvailable(product) <= 0 && (sellOnSoldOut(product.prices, product.type) || isSharedStocksWithOverbooking(product));
      return condition || allowSharedStocksOverBooking(product);
    }

    function refreshPeriod(event, product) {
      //ModalModule.setStatus(ModalStatus.Hidden);
      clickPeriod.value = 0;
      startTime.value = Date.now();
      handleLongClickInterval.value = setTimeout(function () {
        return handleLongClick(product);
      }, 1000);
    }

    function handleLongClick(product) {
      // After 1000 milliseconds, if the user is still holding and there are availabilities then we show pcSelect
      // or if the the pc is retail and it has sellOnSoldOut option.
      // Otherwise we do nothing
      if (allowSelectProduct(product)) {
        // Selecting the PSC and showing the popup
        // ModalModule.setStatus(ModalStatus.Hidden);
        var productCategoryId = product.productCategoryId,
            timeslot_ID = product.timeslot_ID;

        if (productCategoryId && (isRetail(product) || timeslot_ID)) {
          if (timeslot_ID) {
            BookingModule.selectTSID(timeslot_ID);
          }

          BookingModule.selectPCID(productCategoryId.toString());
        }

        ModalModule.setModalProps({
          referrer: ModalStatus.Products,
          goBack: true
        });
        ModalModule.setStatus(ModalStatus.PCSelect);
      } else return;
    }

    function selectProduct(_x2, _x3) {
      return _selectProduct.apply(this, arguments);
    }

    function _selectProduct() {
      _selectProduct = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(event, p) {
        var product, _isRetail, productCategorySelectRes, _product$prices, pssQuantity, pc, price, pssAddons;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (event) event.preventDefault();
                clearInterval(handleLongClickInterval.value);
                endTime.value = Date.now();
                clickPeriod.value = endTime.value - startTime.value;
                product = p;

                if (!product.isRecurring) {
                  _context4.next = 9;
                  break;
                }

                selectedRecurringTicket.value = product;
                _context4.next = 34;
                break;

              case 9:
                if (!(clickPeriod.value < 1000 && allowSelectProduct(product))) {
                  _context4.next = 33;
                  break;
                }

                _isRetail = product.type === PCTypes[PCTypes.Retail];
                _context4.next = 13;
                return selectPC(product, _isRetail);

              case 13:
                productCategorySelectRes = _context4.sent;

                if (!(productCategorySelectRes && productCategorySelectRes.pssQuantity)) {
                  _context4.next = 29;
                  break;
                }

                pssQuantity = productCategorySelectRes.pssQuantity, pc = productCategorySelectRes.pc;
                price = (_product$prices = product.prices) !== null && _product$prices !== void 0 && _product$prices.length ? product.prices[0] : null;
                _context4.next = 19;
                return getPriceNonAutomaticAddons(price);

              case 19:
                pssAddons = _context4.sent;

                if (!(pssAddons.length && hasAddonsEnabled.value)) {
                  _context4.next = 24;
                  break;
                }

                // If product has addons, display PCSelect to allow selecting quantities
                ModalModule.setStatus(ModalStatus.PCSelect);
                _context4.next = 27;
                break;

              case 24:
                _context4.next = 26;
                return addToBasket({
                  selectedProduct: product,
                  pssQuantity: pssQuantity,
                  isRetail: _isRetail,
                  productCategory: pc
                });

              case 26:
                handleNotification();

              case 27:
                _context4.next = 31;
                break;

              case 29:
                ModalModule.setModalProps({
                  referrer: ModalStatus.Products,
                  goBack: true
                });
                ModalModule.setStatus(ModalStatus.PCSelect);

              case 31:
                _context4.next = 34;
                break;

              case 33:
                NotificationService.showCustomError(t("products.tickets-unavailable"));

              case 34:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _selectProduct.apply(this, arguments);
    }

    function handleNotification() {
      if (notification.value) {
        clearInterval(notificationInterval.value);
        notificationCounter.value += 1;
        notification.value.close();
        notification.value = ElNotification({
          title: "".concat(t("common.success"), " X").concat(notificationCounter.value),
          message: t("products.tickets-added"),
          type: "success",
          duration: 0
        });
      } else {
        notification.value = ElNotification({
          title: t("common.success"),
          message: t("products.tickets-added"),
          type: "success",
          duration: 0
        });
        notificationCounter.value = 1;
      } // reset notifications watcher after timeout


      notificationInterval.value = setTimeout(function () {
        var _notification$value;

        (_notification$value = notification.value) === null || _notification$value === void 0 ? void 0 : _notification$value.close();
        notification.value = null;
      }, 4500);
    }

    function isRetail(product) {
      return product.type === PCTypes[PCTypes.Retail];
    }

    function getTranslationForProducts(localeObject) {
      var languageTag = AppModule.language;
      return localeObject[languageTag];
    }

    function countAvailability(product) {
      return product.type === PCTypes[PCTypes.Retail] ? product.prices.length === 1 ? product.prices[0].quantity : sumArray(product.prices.filter(function (pr) {
        return pr.retail.every(function (re) {
          return re.type !== RetailOptionType.Default_Retail_Option;
        });
      }).map(function (pr) {
        return pr.quantity;
      })) : 0;
    }

    function close() {
      ModalModule.setStatus(ModalStatus.Hidden);
    }

    function changeCurrentPage(val) {
      currentPage.value = val;
    }

    function selectDate(date) {
      selectedDate.value = date;
      if (!selectedRecurringTicket.value) return;
      var product = selectedRecurringTicket.value; // redirect user to first available timeslot in calendar for recurring tickets

      var configGrids = POSConfigModule.configGrids;
      var gridtoSelect = configGrids.find(function (grid) {
        return product.ticketGroups.includes(grid.ticketGroupId);
      });

      if (gridtoSelect) {
        POSConfigModule.selectGrid(gridtoSelect); // emit an event to CalendarCards to scroll to the first available time slot

        emitterRef.value.emit("scrollToRecurringTicket", {
          date: date,
          product: product
        }); // wait for CalendarCards to mount in case it's not

        emitterRef.value.on("calendarCardsMounted", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return nextTick();

                case 2:
                  emitterRef.value.emit("scrollToRecurringTicket", {
                    date: date,
                    product: product
                  });

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
      }
    }

    function isDateDisabled(date) {
      var dateJS = dayjs(date); // Disable before today

      if (dateJS.isBefore(dayjs(), "day")) {
        return true;
      }

      return false;
    }

    function openCalendar(id) {
      // display calendar next to the button that clicked it
      var button = document.getElementById("selectButton-".concat(id));

      if (!button) {
        return;
      }

      var datePickerContainer = this.$refs["datePickerContainer"];
      var buttonRect = button.getBoundingClientRect();
      datePickerContainer.style.position = "absolute";
      datePickerContainer.style.left = "".concat(buttonRect.right - 80, "px");
      datePickerContainer.style.top = "".concat(buttonRect.top, "px");
      datepicker.value.focus();
    }

    return {
      modalVisible: modalVisible,
      products: products,
      searchQuery: searchQuery,
      closeIcon: closeIcon,
      productsCount: productsCount,
      pageSize: pageSize,
      currentPage: currentPage,
      paginatedProducts: paginatedProducts,
      selectedDate: selectedDate,
      datepicker: datepicker,
      emitterRef: emitterRef,
      selectProduct: selectProduct,
      updateProducts: updateProducts,
      isRetail: isRetail,
      countAvailability: countAvailability,
      createImageproxyUrl: createImageproxyUrl,
      getTranslationForProducts: getTranslationForProducts,
      close: close,
      changeCurrentPage: changeCurrentPage,
      isProductAvailable: isProductAvailable,
      selectDate: selectDate,
      isDateDisabled: isDateDisabled,
      openCalendar: openCalendar,
      locale: locale,
      productsPssCount: productsPssCount,
      allowSelectProduct: allowSelectProduct,
      refreshPeriod: refreshPeriod,
      canSell: canSell
    };
  },
  mounted: function mounted() {
    this.updateProducts();
    this.emitterRef = this.emitter;
  },
  beforeUnmount: function beforeUnmount() {
    this.emitter.off("calendarCardsMounted");
  },
  methods: {
    /**
     * Takes the Product Category and returns its default RetailOption.SmeetzPictures first item for picture display use
     */
    getDefaultRetailOptionSmeetzPicture: function getDefaultRetailOptionSmeetzPicture(pc) {
      var _pc$prices$find;

      var smeetzPicture = pc.prices.length === 1 ? pc.prices[0].retail[0].smeetzPictures[0] : (_pc$prices$find = pc.prices.find(function (pr) {
        return pr.retail.some(function (rt) {
          return rt.type === RetailOptionType.Default_Retail_Option;
        });
      })) === null || _pc$prices$find === void 0 ? void 0 : _pc$prices$find.retail[0].smeetzPictures[0];
      return smeetzPicture;
    },
    getPictureUrl: function getPictureUrl(pc) {
      var url = pc.type !== PCTypes[PCTypes.Retail] ? pc.product.pictureUrl : createImageproxyUrl(this.getDefaultRetailOptionSmeetzPicture(pc), {
        width: 150,
        height: 150
      });
      return url;
    }
  }
});